import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/admin/Header';
import SideBar from '../components/admin/SideBar';
import Breadcrumbs from '../components/admin/Breadcrumbs';

function AdminLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-background" style={{ backgroundColor: '#F8F8F8' }}>
      <SideBar
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onCollapse={() => setCollapsed(true)}
        onExpand={() => setCollapsed(false)}
      />

      <div className={`flex flex-col flex-1 min-w-0 transition-all duration-300 ${collapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <Header onMenuClick={() => setMobileOpen(true)} collapsed={collapsed} />
        <main className="flex-1 p-4 md:p-6 mt-16 m-4 bg-surface border border-stroke rounded-lg ">
          <div className="w-full">{children || <Outlet />}</div>
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
